import { EntryType, EntryData } from "lib/models";
import Workspace from "./Workspace";
import TextEntryEditor from "./TextEntryEditor";

interface EntryProps {
  uuid: string;
  data: EntryData;
}

const Entry = ({ uuid, data }: EntryProps) => {
  const getEntryComponent = () => {
    if (data.type == EntryType.WORKSPACE) {
      return <Workspace uuid={uuid} data={data} />;
    } else if (data.type == EntryType.TEXT) {
      return <TextEntryEditor uuid={uuid} data={data} />;
    }
    return null;
  };

  return getEntryComponent();
};

export default Entry;
